"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchPeriod = exports.OttStreamType = exports.protobufPackage = void 0;
exports.protobufPackage = "match_card";
var OttStreamType;
(function (OttStreamType) {
    OttStreamType[OttStreamType["OTT_STREAM_TYPE_UNKNOWN"] = 0] = "OTT_STREAM_TYPE_UNKNOWN";
    /** OTT_STREAM_TYPE_PAY_PER_VIEW - Content is behind a subscription or one time payment. */
    OttStreamType[OttStreamType["OTT_STREAM_TYPE_PAY_PER_VIEW"] = 1] = "OTT_STREAM_TYPE_PAY_PER_VIEW";
    /** OTT_STREAM_TYPE_FREE_TO_AIR - Content is available for free. */
    OttStreamType[OttStreamType["OTT_STREAM_TYPE_FREE_TO_AIR"] = 2] = "OTT_STREAM_TYPE_FREE_TO_AIR";
    OttStreamType[OttStreamType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OttStreamType || (exports.OttStreamType = OttStreamType = {}));
var MatchPeriod;
(function (MatchPeriod) {
    MatchPeriod[MatchPeriod["UNKNOWN"] = 0] = "UNKNOWN";
    MatchPeriod[MatchPeriod["PRE_MATCH"] = 1] = "PRE_MATCH";
    MatchPeriod[MatchPeriod["ABANDONED"] = 2] = "ABANDONED";
    MatchPeriod[MatchPeriod["POSTPONED"] = 3] = "POSTPONED";
    MatchPeriod[MatchPeriod["FIRST_HALF"] = 4] = "FIRST_HALF";
    MatchPeriod[MatchPeriod["HALF_TIME"] = 5] = "HALF_TIME";
    MatchPeriod[MatchPeriod["INTERRUPT"] = 6] = "INTERRUPT";
    MatchPeriod[MatchPeriod["PENALTIES"] = 7] = "PENALTIES";
    MatchPeriod[MatchPeriod["SECOND_HALF"] = 8] = "SECOND_HALF";
    MatchPeriod[MatchPeriod["EXTRA_FIRST_HALF"] = 9] = "EXTRA_FIRST_HALF";
    MatchPeriod[MatchPeriod["EXTRA_SECOND_HALF"] = 10] = "EXTRA_SECOND_HALF";
    MatchPeriod[MatchPeriod["FULL_TIME"] = 11] = "FULL_TIME";
    MatchPeriod[MatchPeriod["FULL_TIME_PENALTIES"] = 12] = "FULL_TIME_PENALTIES";
    MatchPeriod[MatchPeriod["RESULTS_AFTER_FULL_TIME"] = 13] = "RESULTS_AFTER_FULL_TIME";
    MatchPeriod[MatchPeriod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MatchPeriod || (exports.MatchPeriod = MatchPeriod = {}));
//# sourceMappingURL=match_card.js.map